module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_v60@2x-c7aecc69039793efb8efa41d8a49a5a1.png";